// this file is the bridge b/w server(s) using the term "VerificationState"
//  and the client side using the term "OptInState" (also used inside the response from the server)
//  to refer to the same concept
import { post } from './commonFetch';
import { Error } from '../types/error';

interface RequestContactPoint {
  travelerKey: string;
  phoneNumberE164: string;
  countryCode: string;
}

interface SearchOptInStateResponseItem {
  accountId: number;
  travelerKey: string;
  phoneNumberE164: string;
  countryCode: string;
  optInState?: Status;
}

export type SearchOptInStateResponse = Array<SearchOptInStateResponseItem>;

export interface SendOptInStateResponse {
  send?: {
    notificationId?: number;
  };
  search?: SearchOptInStateResponse;
}

export const sendOptInSms = (
  accountId: string,
  requestContactPoint: RequestContactPoint,
  resend: boolean,
  isAgent: boolean,
): Promise<SendOptInStateResponse> => {
  const agentOrTraveler = isAgent ? 'agent' : 'traveler';
  const path = resend
    ? `/api/${agentOrTraveler}/verificationState/resend`
    : `/api/${agentOrTraveler}/verificationState/send`;

  return post(path, {
    accountId,
    contactPoint: requestContactPoint,
  });
};

export const notVerified = 'NOT_VERIFIED';
export const VerificationStates = Object.freeze({
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  VERIFIED: 'Verified',
  [notVerified]: 'Not Verified',
});
export type Status = keyof typeof VerificationStates;

export const searchPhoneOptInState = (
  accountId: string,
  requestContactPoint: RequestContactPoint,
  isAgent: boolean,
): Promise<SearchOptInStateResponse> => {
  const agentOrTraveler = isAgent ? 'agent' : 'traveler';
  return post(`/api/${agentOrTraveler}/verificationState/search`, {
    accountId,
    contactPoint: requestContactPoint,
  });
};

interface Failure {
  failureCode: string; //'LANDLINE_NUMBER_NOT_ALLOWED' | 'INVALID_NUMBER_FORMAT' | 'UNKNOWN_PHONE_TYPE', //b/c flow won't let me type-enum this
  description: string;
}

export interface ValidateAndSearchResponse {
  validate?: {
    countryCodeIso2: string;
    countryCodeNumeric: string;
    phoneNumberE164: string;
    isValid: boolean;
    failure?: Failure;
    errors: Array<Error>;
  };
  search?: SearchOptInStateResponse;
}

export const validateAndSearch = (
  requestContactPoint: RequestContactPoint,
  isAgent: boolean,
): Promise<ValidateAndSearchResponse> => {
  const agentOrTraveler = isAgent ? 'agent' : 'traveler';
  return post(`/api/${agentOrTraveler}/notification/validateSMSAndSearch`, {
    contactPoint: requestContactPoint,
  });
};